import { render, staticRenderFns } from "./pharaohsTomb.vue?vue&type=template&id=0648cbf8&"
import script from "./pharaohsTomb.vue?vue&type=script&lang=js&"
export * from "./pharaohsTomb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports